"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _ErrorApi = require("./../../../utils/ErrorApi");

var _ErrorApi2 = _interopRequireDefault(_ErrorApi);

var _Fetch = require("./../../../utils/Fetch");

var _Fetch2 = _interopRequireDefault(_Fetch);

var _ParamsFetch = require("./../../../utils/ParamsFetch");

var _ParamsFetch2 = _interopRequireDefault(_ParamsFetch);

var _JsonFetch = require("./../../../utils/JsonFetch");

var _JsonFetch2 = _interopRequireDefault(_JsonFetch);

var _generateUrl = require("./../../../utils/generateUrl");

var _generateUrl2 = _interopRequireDefault(_generateUrl);

var _UpdateMethods = require("./UpdateMethods");

var UpdateMethods = _interopRequireWildcard(_UpdateMethods);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Rozhraní pro práci s právními formami. Generated from cz.marbes.api.subjekt.PravniFormaService.
 */
// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-01-07T22:16:48Z                      #

// ##############################################################

var PravniFormaApi = function () {
  function PravniFormaApi() {
    (0, _classCallCheck3.default)(this, PravniFormaApi);
  }

  (0, _createClass3.default)(PravniFormaApi, null, [{
    key: "findPravniFormyByIds",

    /**
     * Dohledání právních forem dle seznamu předaných id.
     *
     * @param ids seznam id právních forem
     * @return seznam dohledaných právních forem, pokud bude předáno id neexistující právní formy, bude ignorováno
     */
    value: function findPravniFormyByIds(ids) {
      var uri = serverContextPath + "/api/subjekty/pravniFormy/byIds";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, ids, headers));
    }

    /**
     * Načtení seznamu právních forem.
     *
     * @param typPravniFormy pokud je uvedeno, vrací se právní formy jen pro daný typ, jinak se vrací pro všechny typy
     * @param pridatNeaktivni mají se přidat i neaktivní prání formy?
     * @return seznam právních forem nebo prázdný seznam
     */

  }, {
    key: "getPravniFormy",
    value: function getPravniFormy(typPravniFormy, pridatNeaktivni) {
      var uri = serverContextPath + "/api/subjekty/pravniFormy";
      var headers = undefined;
      var params = { typPravniFormy: typPravniFormy, pridatNeaktivni: pridatNeaktivni };

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Načtení právní formy dle id.
     *
     * @param id id právní formy
     * @return načtená právní forma
     */

  }, {
    key: "getPravniFormaById",
    value: function getPravniFormaById(id) {
      var uri = serverContextPath + ("/api/subjekty/pravniFormy/" + id);
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }
  }]);
  return PravniFormaApi;
}();

exports.default = PravniFormaApi;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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